import './recover_login.scss';
import { qs } from 'music';

window.addEventListener('DOMContentLoaded', () => {
  const submitButton = qs('.js-recover-login');
  const inputElm = qs('.js-username-input');


  const toggleSubmitDisable = () => {
    if (inputElm.value.length > 0) {
      submitButton.removeAttribute('disabled');
    } else {
      submitButton.setAttribute('disabled', '');
    }
  }

  inputElm?.addEventListener('keyup', toggleSubmitDisable);
});
